/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPaymentReceipt} from '../api'

 export const useQueryGetPaymentReceipt = createReactQueryHook('getPaymentReceipt', getPaymentReceipt)
